// Download actions
export const DOWNLOAD_DROPBOX_VAULT_FILES_REQUEST =
  'DOWNLOAD_DROPBOX_VAULT_FILES_REQUEST';
export const DOWNLOAD_DROPBOX_VAULT_FILES_SUCCESS =
  'DOWNLOAD_DROPBOX_VAULT_FILES_SUCCESS';
export const DOWNLOAD_DROPBOX_VAULT_FILES_FAILURE =
  'DOWNLOAD_DROPBOX_VAULT_FILES_FAILURE';
export const DOWNLOAD_DROPBOX_VAULT_FILES_CLEAR =
  'DOWNLOAD_DROPBOX_VAULT_FILES_CLEAR';

// Vault files pagination actions
export const FETCH_DROPBOX_VAULT_FILES_PAGE_SUCCESS =
  'FETCH_DROPBOX_VAULT_FILES_PAGE_SUCCESS';
export const FETCH_DROPBOX_VAULT_FILES_PAGE_FAILURE =
  'FETCH_DROPBOX_VAULT_FILES_PAGE_FAILURE';
export const RESET_DROPBOX_VAULT_FILES_PAGINATION =
  'RESET_DROPBOX_VAULT_FILES_PAGINATION';

// Local pagination actions
export const SET_LOCAL_PAGINATION_PAGE = 'SET_LOCAL_PAGINATION_PAGE';
export const SET_LOCAL_PAGINATION_SIZE = 'SET_LOCAL_PAGINATION_SIZE';

// Folder tab action
export const SET_CURRENT_FOLDER_TAB = 'SET_CURRENT_FOLDER_TAB';

// Auto-download actions
export const SET_AUTO_DOWNLOAD_ELIGIBILITY = 'SET_AUTO_DOWNLOAD_ELIGIBILITY';
export const TRIGGER_DIRECT_DOWNLOAD = 'TRIGGER_DIRECT_DOWNLOAD';

// Search actions
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const SET_SEARCH_ACTIVE = 'SET_SEARCH_ACTIVE';
export const SET_FUZZY_SEARCH_ENABLED = 'SET_FUZZY_SEARCH_ENABLED';
export const SET_SEARCH_ENGINE = 'SET_SEARCH_ENGINE';
